/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resetpassword1Inputs */

const en_resetpassword1 = /** @type {(inputs: Resetpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset Password`)
};

const de_resetpassword1 = /** @type {(inputs: Resetpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset Password" |
*
* @param {Resetpassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resetpassword1 = /** @type {((inputs?: Resetpassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resetpassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resetpassword1(inputs)
	return de_resetpassword1(inputs)
});
export { resetpassword1 as "resetPassword" }